export const APPLICATION = 'application';
export const FHA = 'fha';
export const HARVEST = 'harvest';
export const PLANTING = 'planting';
export const PRESCRIPTIONS = 'prescriptions';
export const WEATHER = 'weather';
